export default __webpack_public_path__ + "static/media/lock-icon.2af271f1.svg";